import { useDialog } from '@shared/hooks';

export const useAdminConversation = () => {
    const {
        open: openCategoryUpsertModal,
        isOpen: isOpenCategoryUpsertModal,
        close: closeCategoryUpsertModal,
    } = useDialog();

    return {
        openCategoryUpsertModal,
        isOpenCategoryUpsertModal,
        closeCategoryUpsertModal,
    };
};
